import { type VueFinalModal, type UseModalOptions } from 'vue-final-modal';

interface PopOverOptions<P extends Component> extends UseModalOptions<P> {
    zIndex?: number;
}

export function usePopOver<
    R = any,
    P extends Component = InstanceType<typeof VueFinalModal>['$props'],
>(_options: PopOverOptions<P>, popOverId?: string) {
    const { isMobile } = useSize(true);
    const { open: openBottomSheet, close: closeBottomSheet } = useBottomSheet<
        R,
        P
    >(
        {
            ..._options,
            attrs: { zIndex: _options.zIndex, ..._options.attrs },
        } as any,
        popOverId
    );
    const { open: openModal, close: closeModal } = {
        ...useModal<R, P>(
            {
                ..._options,
                modalAttrs: {
                    zIndex: _options.zIndex,
                    ...(_options as any).modalAttrs,
                },
            },
            popOverId
        ),
    };
    const open = async (...attrs: Parameters<typeof openModal>) => {
        if (isMobile.value) {
            return await openBottomSheet(attrs[0]);
        } else {
            return await openModal(...attrs);
        }
    };
    const close = () => {
        if (isMobile.value) {
            return closeBottomSheet();
        } else {
            return closeModal();
        }
    };

    return {
        open,
        close,
    };
}
